<template>
  <div class="">
    <div>
      {{  title && title + ","  }}共计{{  tableData.length  }}个提交,{{
       codeSuccessTotal 
      }}个完成，结果<span :style="'color:' + (tableData.length === codeSuccessTotal ? '#67C23A' : '#F56C6C')">{{
         tableData.length === codeSuccessTotal ? "成功" : "失败"  }} <span v-if="msg">，{{msg}}</span></span>
    </div>
    <el-table :cell-style="getRowClass" :header-cell-style="getRowClass" max-height="250" :data="tableData"
      style="width: 100%">
      <el-table-column prop="short_id" label="commit" width="100">
      </el-table-column>
      <el-table-column prop="title" label="message" width="200">
      </el-table-column>
      <el-table-column prop="updated_at" label="时间" width="100">
      </el-table-column>
      <el-table-column prop="name" label="用户" width="120"> </el-table-column>
      <el-table-column prop="body" label="内容"> </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    codeSuccessTotal: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    title: {
      type: String | Number,
      default: () => {
        return "";
      },
    },
    msg: {
      type: String | Number,
      default: () => {
        return "";
      },
    }
  },
  data() {
    return {
      tableDataInit: [],
    };
  },
  computed: {},
  mounted() { },
  methods: {
    getRowClass({ row, column, rowIndex, columnIndex }) {
      // console.log(row, column, rowIndex, columnIndex);
      return "background:#f1fbec";
    },
  },
};
</script>
<style lang="scss" scoped>
</style>

<style  lang="scss">
.table_thir_warp {
  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }

  .el-table__body-wrapper {
    scrollbar-width: thin;
    scrollbar-color: skyblue #eee;
  }

  .el-table__body-wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: skyblue;
    background-image: -webkit-linear-gradient(45deg,
        rgba(255, 255, 255, 0.2) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0.2) 75%,
        transparent 75%,
        transparent);
  }

  .el-table__body-wrapper::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 10px;
  }
}
</style>